import API from 'services/TAPS_API';

export default function getCurrencyList() {
  return API.request({
    method: 'GET',
    url: `/dictionary/currency`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
